import { useEffect } from "react";

/** Matches user-select:text regions in client/src/styles/ (see base.css, messages.css) — tap outside clears Android/iOS text selection. */
const SELECTABLE =
  ".bubble__text, .bubble .bubble__link-preview, input, textarea, select, [contenteditable='true']";

function clearSelectionIfOutside(ev: PointerEvent) {
  const t = ev.target;
  if (!(t instanceof Element)) return;
  if (t.closest(SELECTABLE)) return;
  const s = getSelection();
  if (s?.rangeCount && !s.isCollapsed) s.removeAllRanges();
}

/**
 * On mobile, taps on user-select:none chrome often do not dismiss the native
 * selection popup; clearing selection in JS makes empty areas usable again.
 */
export function useClearSelectionOnOutsideTap() {
  useEffect(() => {
    document.addEventListener("pointerdown", clearSelectionIfOutside);
    return () => document.removeEventListener("pointerdown", clearSelectionIfOutside);
  }, []);
}
